module.exports = __webpack_public_path__ + "static/media/10.b1a428ff.png";